import { Tab, Tabs } from "@mui/material";
import "./styles.css";
import { useContext } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import { sentenceCase } from "../../../constants";
import { removeAllSpaces } from "../../../utils";

const UBAppTabs = ({
  handleChange,
  value,
  variant = "standard",
  tabList,
  isI18nApply = true,
  isSentenceCase = true,
  scrollButtons = false,
  allowScrollButtonsMobile = false,
  className = "",
}) => {
  const [I18n] = useContext(LanguageContext);
  return (
    <Tabs
      value={value}
      onChange={handleChange}
      variant={variant}
      scrollButtons={scrollButtons}
      allowScrollButtonsMobile={allowScrollButtonsMobile}
      className={`UBAppTabsContainer ${className}`.trim()}
    >
      {tabList.map((item) => {
        return (
          <Tab
            id={`${removeAllSpaces(item.value)}_tabId`}
            key={item.label}
            tabIndex={0}
            value={item.value}
            label={`${
              isI18nApply
                ? isSentenceCase
                  ? sentenceCase(I18n[item.label])
                  : I18n[item.label]
                : isSentenceCase
                  ? sentenceCase(item.label)
                  : item.label
            } ${item.posLabelText ? `(${item.posLabelText})` : ""}`}
            sx={{ textTransform: "none" }}
          />
        );
      })}
    </Tabs>
  );
};
export default UBAppTabs;
